import { render, staticRenderFns } from "./CheckoutFooter.vue?vue&type=template&id=cc8f3a38&scoped=true&"
import script from "./CheckoutFooter.vue?vue&type=script&lang=js&"
export * from "./CheckoutFooter.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutFooter.vue?vue&type=style&index=0&id=cc8f3a38&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc8f3a38",
  null
  
)

export default component.exports
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCheckbox,QSeparator,QChip,QBtn,QSpinnerDots});
